/** One list of industries for navigation, homepage and the Industries page. */
export interface IndustryCard { slug: string; title: string; short: string; order: number; image?: string | null; fromCms: boolean }

/**
 * CMS records are authoritative (text, order, image). Bundled industries that were never imported still show,
 * except slugs an editor unpublished or scheduled (`hidden`) — a successful empty CMS list never resurrects those.
 */
export function mergeIndustryList(
  cms: { slug: string; title: string; subtitle: string | null; sort_order: number | null; hero_image_url?: string | null }[],
  bundled: { slug: string; title: string; short: string }[],
  hidden: Set<string>,
): IndustryCard[] {
  const cmsSlugs = new Set(cms.map((c) => c.slug));
  const fromCms = cms.map((c) => ({ slug: c.slug, title: c.title, short: c.subtitle ?? "", order: c.sort_order ?? 0, image: c.hero_image_url, fromCms: true }));
  const rest = bundled.map((b, n) => ({ slug: b.slug, title: b.title, short: b.short, order: n, fromCms: false }))
    .filter((b) => !cmsSlugs.has(b.slug) && !hidden.has(b.slug));
  return [...fromCms, ...rest].sort((a, b) => a.order - b.order);
}
